import React from 'react';
import classNames from 'classnames';
import { Button } from 'components/form-elements/buttons/Button';
import styles from './styles.module.scss';

const weekdays = [
  { name: 'monStart', value: 1 },
  { name: 'tueStart', value: 2 },
  { name: 'wedStart', value: 3 },
  { name: 'thrStart', value: 4 },
  { name: 'friStart', value: 5 },
  { name: 'satStart', value: 6 },
  { name: 'sunStart', value: 0 },
];

export const WeekdayPicker = ({ onClick, selectedDays, className, disabledDays = [] }) => (
  <div className={classNames(styles.weekdays, className)}>
    {(weekdays || []).map((day, index) => {
      const isSelected = selectedDays.includes(day.value);
      const isDisabled = !isSelected && disabledDays.includes(day.value);
      return (
        <Button
          key={index}
          type="button"
          value={day.value}
          onClick={onClick}
          disabled={isDisabled}
          className={classNames(styles.button, isSelected && styles.clickedButton)}
          intl={day.name}
        />
      );
    })}
  </div>
);
